import { Component, OnInit  } from '@angular/core';
import { IntercomService } from '../intercom.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit{
  currentLink:any='';
 
  constructor(private intercomService:IntercomService){
 
  }
  ngOnInit(): void {
    const user=localStorage.getItem('intercomUser')
    if(user!=undefined){
     this.intercomService.initializeIntercom(JSON.parse(user))
    }
  }


}
